import angular from "angular";

angular
    .module('app')
    .component('socialLinksControl', {
        template: require('./social-links-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', '$timeout', controller],
        bindings: {}
    });


function controller($uibModal, Notifier, $http, $timeout) {
    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get('/admin/social-links/get-list', {
                params: {}
            })
            .then(
                function (response) {
                    $ctrl.socLinks = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {
                    console.log(error);
                }
            );
    };

    $ctrl.openSocialLinkForm = function (socLink) {
        $uibModal
            .open({
                component: 'socialLinksForm',
                resolve: {
                    socLink: function () {
                        return socLink;
                    }
                },
                size: 'md',
                keyboard: false,
                backdrop: 'static',
            })
            .result
            .then(
                function (result) {

                    if (socLink) {
                        socLink.id = result.id;
                        socLink.type = result.type;
                        socLink.icon = result.icon;
                        socLink.link = result.link;
                    } else {
                        $ctrl.socLinks.unshift(result);
                    }
                },
                function (error) {

                }
            );
    };

    $ctrl.deleteSocialLinkForm = function (socLink) {
        let params = {
            _method: 'DELETE'
        };
        let req = $http.post(`/admin/social-links/${socLink.id}`, params);

        req.then(
            function (result) {
                let index;

                angular.forEach($ctrl.socLinks, function(link) {
                    if (result.data === link.id) {
                        index = $ctrl.socLinks.indexOf(link);
                    }
                });

                $ctrl.socLinks.splice(index, 1);

                Notifier.success('Успешно удалено', 2);
            },
            function (error) {
                Notifier.error('Ошибка при удалении', 2);
            }
        );

    };
}
